import { Dispatch } from "redux";
import { routes } from "../../../../services/paths";
import { ApiService } from "../../../../services/apiService";
import { handleRequestErrors } from "../../../../shared/utils";
import { appConstants } from "../../../action-constants/inapp.constants";

export const GetImageGallery = (actionPayload: any, isNewBatch: boolean) => {

    if (actionPayload !== "CLEAR") {



        return (dispatch: Dispatch) => {

            let apiConsume = ApiService.request({ url: `${routes.GET_IMAGE_GALLERY}?${actionPayload || ""}`, http_method: "GET" });
            if (!isNewBatch) {
                dispatch(request(apiConsume));
            }
            return apiConsume
                .then((response: any) => {
                    // dispatch(success(response))
                    if (!isNewBatch) {
                        
                        dispatch(success(response))
                    } else {
                        dispatch(nextBatchLoaded(response))
                    }
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.GET_IMAGE_GALLERY_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.GET_IMAGE_GALLERY_SUCCESS, response: response.data, results: response.data.results };
    }
    function nextBatchLoaded(response: any) {
        return { type: appConstants.GET_IMAGE_GALLERY_NEWBATCH, response: response.data, results: response.data.results };
    }
    function failure(error: any) {
        return { type: appConstants.GET_IMAGE_GALLERY_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.GET_IMAGE_GALLERY_RESET, clear_data: "" };
    }
}

export const UploadProductImage = (
  actionPayload: any,
  otherNames: any,
  uploadId?: any,
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: routes.PRODUCT_IMAGE_UPLOAD,
        http_method: "POST",
        data: actionPayload,
      });

      dispatch(request(apiConsume, uploadId));

      return apiConsume
        .then((response: any) => {
          let responseData = {
            ...response.data,
            otherNames,
            meta: { uploadId },
          };
          dispatch(success(responseData));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error), uploadId));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any, uploadId?: any) {
    return {
      type: appConstants.UPLOAD_PRODUCT_PICTURE_PENDING,
      params,
      meta: { uploadId },
    };
  }
  function success(response: any) {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_SUCCESS, response };
  }
  function failure(error: any, uploadId?: any) {
    return {
      type: appConstants.UPLOAD_PRODUCT_PICTURE_FAILURE,
      error,
      meta: { uploadId },
    };
  }
  function clear() {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_RESET, clear_data: "" };
  }
};

export const UpdateProductImage = (
  actionPayload: {
    id: string;
    url: string,
    names: string[];
    name: string;
    imageStatus: number
  } | "CLEAR",
  uploadId?: any
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: routes.PRODUCT_IMAGE_UPDATE,
        http_method: "PUT",
        data: actionPayload,
      });

      dispatch(request(apiConsume, uploadId));

      return apiConsume
        .then((response: any) => {
          let responseData = {
            ...response.data,
            meta: { uploadId },
          };
          dispatch(success(responseData));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error), uploadId));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any, uploadId?: any) {
    return {
      type: appConstants.UPDATE_PRODUCT_PICTURE_PENDING,
      params,
      meta: { uploadId },
    };
  }
  function success(response: any) {
    return { type: appConstants.UPDATE_PRODUCT_PICTURE_SUCCESS, response };
  }
  function failure(error: any, uploadId?: any) {
    return {
      type: appConstants.UPDATE_PRODUCT_PICTURE_FAILURE,
      error,
      meta: { uploadId },
    };
  }
  function clear() {
    return { type: appConstants.UPDATE_PRODUCT_PICTURE_RESET, clear_data: "" };
  }
};

export const GetImage = (actionPayload: any) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.GET_IMAGE}?${actionPayload || ""}`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          // dispatch(success(response))
          dispatch(success(response));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.GET_IMAGE_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.GET_IMAGE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_IMAGE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_IMAGE_RESET, clear_data: "" };
  }
};

export const DownloadImage = (actionPayload: any) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.DOWNLOAD_IMAGE}?${actionPayload || ""}`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          // dispatch(success(response))
          dispatch(success(response));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.DOWNLOAD_IMAGE_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.DOWNLOAD_IMAGE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DOWNLOAD_IMAGE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DOWNLOAD_IMAGE_RESET, clear_data: "" };
  }
};

export const DeleteImage = (actionPayload: any) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.DELETE_IMAGE}?${actionPayload || ""}`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          // dispatch(success(response))
          dispatch(success(response));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.DELETE_IMAGE_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.DELETE_IMAGE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DELETE_IMAGE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DELETE_IMAGE_RESET, clear_data: "" };
  }
};